import React, { useMemo, useState } from "react";
import "./DesignerLayersPanel.css";

const DesignerLayersPanel = ({
  objects,
  selectedObjectIds = [],
  selectedGroupId = null,
  onSelectObject,
  updateObjectFields,
  onDeleteObject,
  onDuplicateObject,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const sortedObjects = useMemo(() => {
    return [...objects].sort((a, b) => {
      const az = a.z_index ?? 0;
      const bz = b.z_index ?? 0;
      if (az !== bz) return bz - az;
      return String(b.id).localeCompare(String(a.id));
    });
  }, [objects]);

  const handleSelect = (event, objectId) => {
    const multi = Boolean(event?.ctrlKey || event?.metaKey);
    onSelectObject?.(objectId, multi);
  };

  if (collapsed) {
    return (
      <div className="dlp-collapsed-wrap">
        <button
          type="button"
          className="dlp-collapse-toggle dlp-collapse-toggle--collapsed"
          onClick={() => setCollapsed(false)}
        >
          Layout / Layers
        </button>
      </div>
    );
  }

  return (
    <div className="dlp-panel">
      <div className="dlp-header">
        <h3 className="dlp-title">Layout / Layers</h3>

        <button
          type="button"
          className="dlp-collapse-toggle"
          onClick={() => setCollapsed(true)}
        >
          −
        </button>
      </div>

      {sortedObjects.length === 0 ? (
        <p className="dlp-empty">No objects found in this page.</p>
      ) : (
        <div className="dlp-list">
          {sortedObjects.map((obj) => {
            const isSelected =
              selectedObjectIds.includes(obj.id) ||
              (selectedGroupId && obj.group === selectedGroupId);

            return (
              <div
                key={obj.id}
                className={`dlp-row ${isSelected ? "dlp-row--selected" : ""}`}
                onClick={(e) => handleSelect(e, obj.id)}
              >
                <div className="dlp-row-top">
                  <div className="dlp-name" title={obj.name}>
                    {obj.name || `Object ${obj.id}`}
                  </div>

                  <div className="dlp-meta">
                    <span className="dlp-badge">{obj.type}</span>
                    {obj.group && (
                      <span className="dlp-badge">g:{obj.group}</span>
                    )}
                    <span className="dlp-badge">
                      {obj.width}×{obj.height}
                    </span>
                  </div>
                </div>

                <div
                  className="dlp-row-bottom"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="dlp-bottom-left">
                    <span className="dlp-badge">z: {obj.z_index ?? 0}</span>
                  </div>

                  <div className="dlp-actions">
                    <label className="dlp-check">
                      <input
                        type="checkbox"
                        checked={obj.visible !== false}
                        onChange={() =>
                          updateObjectFields(obj.id, {
                            visible: !(obj.visible !== false),
                          })
                        }
                      />
                      <span>Show</span>
                    </label>

                    <label className="dlp-check">
                      <input
                        type="checkbox"
                        checked={!!obj.locked}
                        onChange={() =>
                          updateObjectFields(obj.id, {
                            locked: !obj.locked,
                          })
                        }
                      />
                      <span>Lock</span>
                    </label>

                    <button
                      type="button"
                      className="dlp-action-btn"
                      title="Duplicate"
                      onClick={() => onDuplicateObject?.(obj.id)}
                    >
                      ⧉
                    </button>

                    <button
                      type="button"
                      className="dlp-delete-btn"
                      title="Delete"
                      onClick={() => onDeleteObject?.(obj.id)}
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DesignerLayersPanel;